import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAiccO1bQXmAls06B6J-KxfABvmBOEn5rc",
  authDomain: "blobchat-production.firebaseapp.com",
  projectId: "blobchat-production",
  storageBucket: "blobchat-production.appspot.com",
  messagingSenderId: "151597986495",
  appId: "1:151597986495:web:b9a3722ed416c824dfcc0a",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
